import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ResourcesPage from '@pages/resources/ResourcesPage';
import ResourceViewPage from '@pages/resources/ResourceViewPage';
import ResourceEditPage from '@pages/resources/ResourceEditPage';
import ResourceCreatePage from '@pages/resources/ResourceCreatePage';
import ResourceBorrowPage from '@pages/resources/ResourceBorrowPage';
import ResourceConsumePage from '@pages/resources/ResourceConsumePage';
import ResourceRefillPage from '@pages/resources/ResourceRefillPage';
import ResourceReservePage from '@pages/resources/ResourceReservePage';

export const ResourcesRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<ResourcesPage />} />
            <Route path="/create" element={<ResourceCreatePage />} />
            <Route path="/:id" element={<ResourceViewPage />} />
            <Route path="/:id/edit" element={<ResourceEditPage />} />
            <Route path="/:id/borrow" element={<ResourceBorrowPage />} />
            <Route path="/:id/consume" element={<ResourceConsumePage />} />
            <Route path="/:id/refill" element={<ResourceRefillPage />} />
            <Route path="/:id/reserve" element={<ResourceReservePage />} />
        </Routes>
    );
};

export default ResourcesRoutes;
